import React from 'react';
import Dialog from './Dialog';
import useDialogMutation from '../hooks/useDialogMutation';

function DeleteVaultToolDialog({ app, onConfirm, onClose }) {
  const { run, saving, error } = useDialogMutation();

  return (
    <Dialog title={`Delete "${app.name}"?`} onClose={onClose} locked={saving}>
      <p className="dialog-text">Permanently delete this Vault tool and its application record. This can't be undone.</p>
      {error && <p className="dialog-error" role="alert">{error}</p>}
      <div className="dialog-actions">
        <button type="button" className="btn" onClick={onClose} disabled={saving}>Cancel</button>
        <button
          type="button"
          className="btn btn-danger"
          disabled={saving}
          onClick={() => run(() => onConfirm(app.id), onClose)}
        >
          {saving ? 'Deleting…' : 'Delete'}
        </button>
      </div>
    </Dialog>
  );
}

export default DeleteVaultToolDialog;